export default __webpack_public_path__ + "static/media/8a8971edb82f5226134fc8912dcaed751602953965522.1fbefda2.webp";